document.addEventListener('DOMContentLoaded', () => {
  const path = (value) => {
    try {
      const pathname = new URL(value, window.location.origin).pathname.replace(/\/$/, '');
      return pathname || '/';
    } catch {
      return '';
    }
  };
  const currentPath = path(location.pathname);

  document.querySelectorAll('[data-optimum-hover-menu]').forEach((menu) => {
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      menu.open = true;
    };
    const close = (event) => {
      if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
      closeTimer = setTimeout(() => { menu.open = false; }, 180);
    };
    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseover', open);
    menu.addEventListener('mouseleave', close);
    menu.addEventListener('mouseout', close);
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) close(event);
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });
  });

  document.querySelectorAll('[data-optimum-menu-link]').forEach((link) => {
    if (path(link.href) !== currentPath) return;
    link.classList.add('header__active-menu-item');
    link.setAttribute('aria-current', 'page');
    link.closest('[data-optimum-hover-menu]')?.querySelector('summary')?.classList.add('header__active-menu-item');
  });

  document.querySelectorAll('[data-optimum-menu-toggle]').forEach((toggle) => {
    const drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    const panel = drawer?.querySelector('[role="dialog"]');
    const closeButton = drawer?.querySelector('[data-optimum-menu-close]');
    const headerSection = toggle.closest('.section-header');
    if (!drawer || !panel || !closeButton) return;

    const close = () => {
      drawer.hidden = true;
      headerSection?.classList.remove('optimum-mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    };
    const open = () => {
      drawer.hidden = false;
      headerSection?.classList.add('optimum-mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      closeButton.focus();
    };

    toggle.addEventListener('click', () => (drawer.hidden ? open() : close()));
    closeButton.addEventListener('click', close);
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) close();
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') return close();
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), summary')].filter((element) => {
        const closedDetails = element.closest('details:not([open])');
        return !closedDetails || element === closedDetails.querySelector(':scope > summary');
      });
      const first = focusable[0];
      const last = focusable.at(-1);
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
});
